import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import PropTypes from 'prop-types';
import { css } from 'styled-components';

import ConditionsTextBlock from 'components/ConditionsTextBlock/ConditionsTextBlock';

const Contracts = ({ contracts, color }) => {
  if (!contracts || contracts.length === 0) {
    return <></>;
  }
  const currentContract = contracts[0];
  const previousContracts = contracts
    .filter(({ current }) => !current)
    .map(({ version, url }, previousContractIndex) => (
      <Box
        marginBottom="8x"
        key={`contract${version}`}
      >
        <Link
          intlKey="CUENTA.CONDITIONS.PREVIOUS.FILE.LINK_TEXT"
          intlValues={{
            untilDate: contracts[previousContractIndex].created_date,
          }}
          typographyProps={{
            variant: 'subtitle2',
          }}
          css={css`color: ${color}`}
          rel="noopener"
          type="application/pdf"
          target="_blank"
          href={url}
        />
      </Box>
    ));

  return (
    <>
      <ConditionsTextBlock
        titleIntlKey="CUENTA.CONDITIONS.CURRENT.FILE.TEXT"
        titleIntlValues={{
          link: (
            <Link
              intlKey="CUENTA.CONDITIONS.CURRENT.FILE.LINK_TEXT"
              css={css`color: ${color}`}
              variant="action"
              typographyProps={{
                variant: 'heading4',
              }}
              rel="noopener"
              type="application/pdf"
              target="_blank"
              href={currentContract.url}
            />
          ),
        }}
      />
      {previousContracts && previousContracts.length > 0 && (
      <>
        <Typography
          marginTop="16x"
          marginBottom="16x"
          variant="subtitle1"
          intlKey="CUENTA.CONDITIONS.PREVIOUS.FILE.TEXT"
          strong
        />
        {previousContracts}
      </>
      )}
    </>
  );
};

Contracts.defaultProps = {
  contracts: null,
  color: '#7B4DD6',
};

Contracts.propTypes = {
  color: PropTypes.string,
  contracts: PropTypes.arrayOf(
    PropTypes.shape({
      created_date: PropTypes.string.isRequired,
      current: PropTypes.bool.isRequired,
      url: PropTypes.string.isRequired,
      version: PropTypes.number.isRequired,
    }),
  ),
};

export default React.memo(Contracts);
